import React, { useState, useEffect, useRef } from 'react';

import TickIconBlack from '../../assets/img/tick-icon-black.png';
import UploadIcon from '../../assets/img/upload-icon.svg';
import DeletePopup from './DeletePopup';
import Loader from './loader';
import $ from "jquery";

import {
    uploadFileViaMultipart,
    removeFile
} from "../../Actions/uploadFileActions";

import { useDispatch, useSelector } from "react-redux";

import CustomPopUp from './customPopUp';

function ABUploadEdu3(props) {

    const dispatch = useDispatch();

    //Handling Initial States Floating Labels
    const [formData, setFormData] = useState({
        other: null,
    });
    const [fileLength, setFileLength] = useState();

    //Handling Floating Labels
    const handleFloatingLabels = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    }

    const { name, id, title, record, placeholder, fieldId, isRequired, getCount, totalCount } = props;

    //   alert(totalCount);

    const [count3, setCount3] = useState();


    useEffect(() => {
        setCount3(totalCount);
    }, [totalCount]);


    ///////////////////////////////////////////////////////////

    // upload file handle
    const uploadFile = (event) => {
        //console.log(caseCheckId);
        // console.log($("input:file")[0].files.length);
        const chosenFiles = event.target.files;

        setFileLength(chosenFiles.length);

        console.log(chosenFiles);


        // const record = {};
        // record.caseCheckId = caseCheckId;
        // record.docId = docId;
        let err_id = 'err_document_' + record.docId + '_count_' + record.caseCheckId;
      document.getElementById(err_id).innerHTML = '';
        //calling file upload api
        dispatch(uploadFileViaMultipart("check_documents", chosenFiles, record));


        // setIsFileUploadedObject((prevState) => ({
        //   ...prevState,
        //   [fieldName]: true,
        // }));
    };

    const [isLoading, setIsLoading] = useState(false);

    const uploadStoreData = useSelector((state) => state.savedFileDetails);

    const { saveFileUploadData, loading: uploadLoad, error: uploadError } = uploadStoreData;

    useEffect(() => {
        if (typeof uploadLoad !== "undefined" && uploadLoad !== null) {
            if (uploadLoad === true) {
                setIsLoading(true);
            } else {

                setIsLoading(false);
                // setCount(1);
                //dispatch(getEducation());
              // props.reRenderAgain();
            }


        }
    }, [saveFileUploadData]);

    useEffect(() => {

        if (typeof saveFileUploadData.data !== "undefined" && saveFileUploadData.data !== null && saveFileUploadData.status == "success") {

        //    setCount(count + 1);
           //  if(Object.keys(saveFileUploadData.data).length > 0){
                setCount3(Object.keys(saveFileUploadData.data).length)
           //  }

            // setCount(Object.keys(saveFileUploadData.data).length);

            //     alert('#doc_' + record.docId);

            // $('#doc_'+record.docId).addClass("show");
            // $('#doc_'+record.docId).removeClass("hidden");

            // }else{
            //     $('#doc_'+record.docId).removeClass("show");
            //     $('#doc_'+record.docId).addClass("hidden");
            // }
            //dispatch(getEducation());
            //props.reRenderAgain();

        }
    }, [saveFileUploadData, uploadStoreData]);


    // const handleChange = (selectedOption) => {

    //     setReactSelect(selectedOption);

    //     props.selectOption({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });
    //     setShowFilterDiv(false);
    //     //setKeyword(selectedOption.name);

    //     if (type === 3) {

    //         inputText.current.value = selectedOption.name;

    //     }

    //     //if this is an auto suggeest and other is selected then do something

    //     if (type === 3 && selectedOption.value === 'other') {

    //         alert("other selected");

    //     }

    //     //if this is an auto suggeest and other is selected then do something

    // };

    const [showModal, setShowModal] = useState(0);

    const closeModal = () => {
        setShowModal(0);
    };

    const openModal = () => {
        setShowModal(1);
    };

    const [showDeleteModal, setShowDeleteModal] = useState(0);



    const closeDeleteModal = () => {
        setShowDeleteModal(0);
    };

    const openDeleteModal = () => {
        setShowDeleteModal(1);
    };

    const deleteHandler = () => {

        setShowDeleteModal(1);


    };

    const proceedDelete = () => {

        const recordArray = {};
        recordArray.doc_chk = record.caseCheckId;
        recordArray.doc_ids = record.docId;
        recordArray.doc_ref = 'all';

        //calling file upload api
        dispatch(removeFile("check_documents", recordArray));

        props.reRenderAgain();

        setShowDeleteModal(0);
    };



    return (
        <>
            {isLoading && <Loader />}
            <div className="row mt-3">
                <div className="col-sm-4 col-md-12 col-xl-4">

                    <div className="upload-box">
                        <div className="d-flex align-items-center">
                            <img src={UploadIcon} className="mr-2 pl-3 pr-3" alt="" />
                        </div>

                        <label htmlFor="file-upload">
                            <span>
                                <h6 className="m-0">{title}  {isRequired == 1 && <sup className="text-danger">*</sup>}</h6>

                                {/* <small className="text-muted">2 Files uploaded</small> */}
                            </span>
                            <div className="right text-right w-100">
                                <div className="border rounded position-relative">
                                    <small className="text-muted" style={{ position: 'absolute', left: '10px', top: '5px' }}>Choose Files</small>
                                    <input
                                        id={id}
                                        type="file"
                                        style={{ opacity: "0", width: '100%' }}
                                        accept="image/*"
                                        multiple
                                        onChange={(e) => uploadFile(e)}
                                    // params => caseCheckId, docId
                                    // onChange={(e) => uploadFile(e)}
                                    ></input>



                                    {/* <img src={CrossIcon} alt="" className="remove-btn" /> */}
                                </div>

                            </div>
                            <small >JPG,PNG,PDF,JPEG formats are supported</small>
                        </label>

                    </div>
                    {count3 > 0 &&
                        <small className="text-muted" >{count3} files uploaded</small>

                    }

                </div>

                {/* {
          "col-auto d-flex align-items-center actions-mbl " + (count >= 1 ? "show" : "hidden")
        } */}

                {/* <div className= {
          "col-auto d-flex align-items-center actions-mbl " + (getCount >= 1 ? "show" : "hidden")
        } id={`doc_${record.docId}`}> */}

                {count3 > 0 && (

                    <div className={
                        "col-auto d-flex align-items-center actions-mbl"
                    } id={`doc_${record.docId}`}>
                        {/* {(count >= 1) &&  */}
                        <>
                            <i class="fas fa-eye mr-3 cursor-pointer" onClick={openModal}></i>
                            <i class="fas fa-trash-alt text-danger cursor-pointer" onClick={deleteHandler}></i>
                        </>
                        {/* }      */}
                    </div>

                )}

            </div>



            {showDeleteModal === 1 &&
                <DeletePopup
                    showModalBox={showDeleteModal}
                    closePopup={closeDeleteModal}
                    title="Delete Images"
                    description="Are you sure you want to delete? This action cannot be undone."
                    proceedHandler={proceedDelete}
                // record={record}
                />
            }

            {showModal === 1 &&
                <CustomPopUp
                    showModalBox={showModal}
                    closePopup={closeModal}
                    record={record}
                    title={title}
                />
            }


        </>
    );
}

export default ABUploadEdu3;
